import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './styles.css';

// Use localhost in development, production API otherwise
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 
  (process.env.NODE_ENV === 'development' || window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
    ? 'http://localhost:5001'
    : 'https://api-eternavaults.onrender.com');

export default function PartnerInvite() {
  const { token } = useParams();
  const navigate = useNavigate();
  
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [partner, setPartner] = useState(null);

  useEffect(() => {
    activateAccount();
  }, [token]);

  const activateAccount = async () => {
    try {
      setLoading(true);
      setError(null);
      console.log('🔍 Calling API:', `${API_BASE_URL}/api/partner/invite/${token}`);
      
      // Add timeout to prevent hanging
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 30000); // 30 second timeout
      
      const response = await fetch(`${API_BASE_URL}/api/partner/invite/${token}`, {
        signal: controller.signal
      });
      
      clearTimeout(timeoutId);
      
      let data;
      try {
        data = await response.json();
      } catch (jsonError) {
        console.error('❌ Failed to parse JSON response:', jsonError);
        setError(`Server error: ${response.status} ${response.statusText}`);
        setLoading(false);
        return;
      }
      
      console.log('📥 API Response:', { status: response.status, data });
      
      if (!response.ok) {
        setError(data.error || data.details || `Server error: ${response.status}`);
        setLoading(false);
        if (data.partner) {
          setPartner(data.partner);
        }
        return;
      }

      if (data.passwordResetUrl) {
        console.log('✅ Redirecting to Auth0:', data.passwordResetUrl);
        // Small delay to ensure state updates are visible
        setTimeout(() => {
          window.location.href = data.passwordResetUrl;
        }, 100);
      } else {
        console.error('❌ No passwordResetUrl in response:', data);
        setPartner(data.partner || null);
        setError('Password reset URL not received. Please contact support.');
        setLoading(false);
      }
    } catch (error) {
      if (error.name === 'AbortError') {
        console.error('❌ Request timeout');
        setError('Request timed out. Please check your connection and try again.');
      } else {
        console.error('❌ Error activating account:', error);
        setError(`Failed to activate account: ${error.message || 'Network error'}`);
      }
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="partner-invite-container">
        <div className="partner-invite-card">
          <h1>Setting Up Your Account...</h1>
          <p>Redirecting to Auth0 to set your password...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="partner-invite-container">
        <div className="partner-invite-card error">
          <h1>Account Setup Error</h1>
          <p>{error}</p>
          {partner && (
            <div className="partner-info" style={{ marginTop: '1rem', padding: '1rem', background: 'rgba(200, 170, 110, 0.1)', borderRadius: '8px' }}>
              <p><strong>Name:</strong> {partner.name}</p>
              <p><strong>Email:</strong> {partner.email}</p>
            </div>
          )}
          <div style={{ marginTop: '1.5rem' }}>
            <button onClick={() => navigate('/partner/login')} className="submit-button">
              Go to Login
            </button>
            <button onClick={() => navigate('/')} style={{ marginLeft: '1rem', background: 'transparent', border: '1px solid #C8AA6E', color: '#C8AA6E' }}>
              Go Home
            </button>
          </div>
        </div>
      </div>
    );
  }

  return null; // Should not reach here as we redirect
}

